export default {
  initialUserData() {
    return {
      username: null,
      password: null,
      role: '',
      profile: {
        mobile: null,
        name: null,
        nickname: null,
      },
      pt: {
        general: 0,
      },
      source: '',
      type: 'SEAMLESS',
      url: '',
      currency: '',
      userPermission: {
        member: 'off',
        report: 'off',
        statement: 'off',
        seamless: 'off',
        useronline: 'off',
        suggestion: 'off',
        apikey: 'off',
      },
      permission: {
        isRefillCredit: false,
        isDeductCredit: false,
        fullMemberAccess: false,
        viewMemberAccess: false,
        reportAccess: false,
      },
      websiteUrl: '',
      ipWhitelist: [],
      isFeature: true,
    };
  },
  UserType: [
    {
      text: 'AGENT',
      value: 'AGENT',
    },
    {
      text: 'MEMBER',
      value: 'MEMBER',
    },
    {
      text: 'SUBACCOUNT',
      value: 'SUBACCOUNT',
    },
  ],
};
